
import MapViewerReservations from '@apps/components/mapViewers/tests/MapViewerReservations';
import PieMap from '@apps/components/mapViewers/tests/PieMap';
function PgPubPieMap() {
  
  return (
      <PieMap />
  );
}

export default PgPubPieMap;

